import React from 'react';
import {
  Figure, colors, Row, Column, Banner as StyledBanner,
} from 'globalStyle';
import { Title, Text } from 'components/Texts';
import { Hollow, colorType } from 'components/Buttons';
import { routes } from 'routes';
import completeProfile from 'assets/persons/complete-user-profile-1.svg';
import { userStateType } from 'types/userStateType';

export const Banner = ({
  userData = null,
}) => {
  if (userData?.nameState !== userStateType.PASSWORD_VERIFIED) return null;

  return (
    <div>
      <StyledBanner mtb={50} background={colors.primary} height="203px">
        <Row pr={40} pl={40}>
          <Column col={5}>
            <Figure>
              <img src={completeProfile} alt="complete profile" />
            </Figure>
          </Column>
          <Column col={7} pt={60} pb={60} space={80}>
            <Title
              number={3}
              mb={20}
              color={colors.WHITE}
            >
              ¡Ya casi puedes invertir!

            </Title>
            <Text
              color={colors.WHITE}
              number={3}
              mb={50}
            >
              Para invertir, ayúdanos llenando un poco de información sobre ti que nos falta.
            </Text>
            <Hollow
              onColorType={colorType.BLUE}
              href={routes.profile.route}
            >
              Completa la información
            </Hollow>
          </Column>
        </Row>
      </StyledBanner>
    </div>
  );
};
